import React from 'react';
import {useParams} from 'react-router-dom';
import {FeatureFlagEnum, ModuleEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkWorkflows} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useModulePermissions} from 'src/shared/auth/permissions/useModulePermissions';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useUrlQueryTabV2} from 'src/shared/hooks/useUrlQueryTabV2';
import {WorkflowDocumentTitle} from 'src/app/workflows/workflowHelpers';
import {ManageWorkflows} from './components/ManageWorkflows';
import {NexusTab} from './components/NexusTab';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export type WorkflowsDashViewType = 'nexus' | 'manage' | '' | ':view';

const WorkflowsDashPage: React.FC = () => {
  useSetDocumentTitle(WorkflowDocumentTitle);

  const perms = useModulePermissions(ModuleEnum.Workflows);
  const navigate = useAppNavigate();
  const {view} = useParams();

  const {RenderedTabsComponent} = useUrlQueryTabV2<WorkflowsDashViewType>({
    view: (view ?? 'nexus') as WorkflowsDashViewType,
    defaultView: 'nexus',
    tabs: [
      {
        view: 'nexus',
        label: 'Nexus',
        component: <NexusTab />,
      },
      {
        view: 'manage',
        label: 'Manage Workflows',
        disabled: !perms.update && !perms.create,
        component: <ManageWorkflows />,
      },
    ],
    onSelectView: view => {
      navigate(PathUtility.WorkflowsDashboard(view as WorkflowsDashViewType));
    },
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Workflows}>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkWorkflows.icon}
          subtitle="Automate processes and tasks">
          Workflows
        </PageHeader.Title>
      </PageHeader>
      {RenderedTabsComponent}
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.WorkflowsDashboard(':view'),
  element: <WorkflowsDashPage />,
  isPrivate: true,
});

export default WorkflowsDashPage;
